import { render, staticRenderFns } from "./PesquisaNecessidades.vue?vue&type=template&id=60487273&scoped=true"
import script from "./PesquisaNecessidades.vue?vue&type=script&lang=js"
export * from "./PesquisaNecessidades.vue?vue&type=script&lang=js"
import style0 from "./PesquisaNecessidades.vue?vue&type=style&index=0&id=60487273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60487273",
  null
  
)

export default component.exports